import Component from '@glimmer/component';
import { cached, tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import ContactsCache from 'donor-elf-web/services/contacts-cache';

interface ComponentArgs {
  contactId: string;
  hideMoreInfoDropdown?: boolean; // default false
}

export default class ContactComponent extends Component<ComponentArgs> {
  @service declare contactsCache: ContactsCache;

  @tracked standinTrigger = true;

  get showMoreInfoDropdown() {
    return this.args.hideMoreInfoDropdown !== true && this.contact != null;
  }

  removeStandinTrigger = () => {
    this.standinTrigger = false;
  };

  @cached
  get contact() {
    return this.contactsCache.getById(this.args.contactId);
  }
}
